export default __webpack_public_path__ + "static/media/14g28mmow.9cc4793f.jpeg";